import firedux from '../firedux'
import {dispatch} from '../store'

import {SETTINGS_ENDPOINT} from '../../config/constants'

import setChatSettings from '../actions/set_chat_settings'

export const watchChatSettings = () => {
  dispatch(setChatSettings()) // initiate with defaults

  firedux.ref.child(SETTINGS_ENDPOINT).on('value', (snapshot) => {
    if (snapshot.val()) return dispatch(setChatSettings(snapshot.val()))
  })
}




/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/chat_settings.js
 **/